import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * Card Props
 */
export default class Props extends Mixins() {
    /**
     * Cart  HTML Tag
     */
    @Prop({ default: 'div' }) tag!: string;

    /**
     * Cart  Title
     */
    @Prop({ type: String }) title!: string;

    /**
     * Cart  Subtitle
     */
    @Prop({ type: String }) subtitle!: string;

    /**
     * Cart  Image src
     */
    @Prop({ type: Object }) src!: object;

    /**
     * Cart  Height
     */
    @Prop({ default: '300px' }) height!: string;

    /**
     * Cart  Button Color
     */
    @Prop({ default: 'primary' }) buttonColor!: string;

    /**
     * Cart  Button Size
     */
    @Prop({ default: 'medium' }) buttonSize!: string;

    /**
     * Cart  Button HTML Tag
     *
     * @values "button", "a", "router-link"
     */
    @Prop({ default: 'router-link' }) buttonTag!: string;

    /**
     * Cart  Button object of Vue Router
     *
     * Tag should be `router-link`
     */
    @Prop() to!: Record<string, unknown>;

    /**
     * Cart  Button href of the link
     *
     * Tag should be `a`
     */
    @Prop() href!: string;

    /**
     * Cart  Button Content
     */
    @Prop() buttonContent!: string;

    /**
     * Version of the Images
     */
    @Prop({ type: String }) imageVersion!: string;

    /**
     * Color of background
     */
    @Prop({ type: String }) color!: string;

    /**
     * Hide overlay on image
     */
    @Prop({ type: Boolean }) noOverlay!: boolean;
}
